module.exports = __webpack_public_path__ + "img/finger.1cdd660a.png";